import { currencyFormat } from '@/utils/currencyFormatter';

import React from 'react';
import styled from 'styled-components';
import { colors } from '@/constants/colors';

const Basic = ({ colorTheme }: { colorTheme: string }) => {
   return (
      <Wrapper>
         <SectionLabel>Choose a plan</SectionLabel>
         <CardList>
            <Card $color={colorTheme}>
               <CardLeft>
                  <DurationBadge $color={colorTheme}>1 Hr</DurationBadge>
                  <CardTitle>Unlimited Internet</CardTitle>
                  <CardDesc>1 Hour of unli internet</CardDesc>
               </CardLeft>
               <CardRight>
                  <CardPrice $color={colorTheme}>₱15</CardPrice>
                  <BuyBtn $color={colorTheme}>Buy Now</BuyBtn>
               </CardRight>
            </Card>

            <Card $color={colorTheme}>
               <CardLeft>
                  <DurationBadge $color={colorTheme}>3 Hrs</DurationBadge>
                  <CardTitle>Unlimited Internet</CardTitle>
                  <CardDesc>3 Hours of unli internet</CardDesc>
               </CardLeft>
               <CardRight>
                  <CardPrice $color={colorTheme}>₱50</CardPrice>
                  <BuyBtn $color={colorTheme}>Buy Now</BuyBtn>
               </CardRight>
            </Card>

            <Card $color={colorTheme}>
               <CardLeft>
                  <DurationBadge $color={colorTheme}>1 Day</DurationBadge>
                  <CardTitle>Unlimited Internet</CardTitle>
                  <CardDesc>24 Hours of unli internet</CardDesc>
               </CardLeft>
               <CardRight>
                  <CardPrice $color={colorTheme}>₱80</CardPrice>
                  <BuyBtn $color={colorTheme}>Buy Now</BuyBtn>
               </CardRight>
            </Card>
         </CardList>
      </Wrapper>
   );
};

const Wrapper = styled.div``;

const SectionLabel = styled.p`
   font-size: 9px;
   font-weight: 600;
   color: ${colors.GRAY5};
   text-transform: uppercase;
   letter-spacing: 0.3px;
   margin-bottom: 6px;
`;

const CardList = styled.div`
   display: flex;
   flex-direction: column;
   gap: 6px;
`;

const Card = styled.div<{ $color: string }>`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 8px;
   border: 1px solid #eee;
   border-radius: 8px;
   padding: 8px 10px;
`;

const CardLeft = styled.div`
   flex: 1;
   min-width: 0;
`;

const CardRight = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-end;
   gap: 4px;
   flex-shrink: 0;
`;

const DurationBadge = styled.div<{ $color: string }>`
   display: inline-block;
   font-size: 8px;
   font-weight: 700;
   padding: 1px 5px;
   border-radius: 4px;
   margin-bottom: 3px;
   background: ${({ $color }) => `${$color}15`};
   color: ${({ $color }) => $color};
`;

const CardTitle = styled.p`
   font-size: 10px;
   font-weight: 600;
   color: ${colors.GRAY_DARK};
   line-height: 1.3;
`;

const CardDesc = styled.p`
   font-size: 8px;
   color: ${colors.GRAY5};
   line-height: 1.3;
`;

const CardPrice = styled.p<{ $color: string }>`
   font-size: 14px;
   font-weight: 800;
   color: ${({ $color }) => $color};
`;

const BuyBtn = styled.button<{ $color: string }>`
   background: ${({ $color }) => $color};
   color: white;
   border: none;
   border-radius: 5px;
   padding: 3px 10px;
   font-size: 8px;
   font-weight: 600;
   cursor: pointer;
`;

export default Basic;
